import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import Datetime from 'react-datetime';
import Select from 'react-select';
import axios from 'axios';

import routes from 'app/routes';
import affiliate_payment_statuses from 'data/affiliate_payment_statuses';

export default function Filters({
  keyword,
  setKeyword,
  filterDate,
  setFilterDate,
  filterStatus,
  setFilterStatus,
}) {
  return (
    <div className="invite_search">
      <Row>
        <Col md={3}>
          <input
            type="text"
            className="form-control"
            placeholder="Search"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
          />
        </Col>

        <Col md={3}>
          <Datetime
            inputProps={{ placeholder: 'Date' }}
            value={filterDate != null ? filterDate : ''}
            timeFormat={false}
            onChange={(date) => setFilterDate(date)}
            renderInput={(props) => (
              <input
                {...props}
                value={
                    filterDate != null
                      ? typeof filterDate === 'string'
                        ? filterDate
                        : filterDate.format('MM/DD/YYYY')
                      : ''
                  }
              />
            )}
          />
        </Col>

        <Col md={3}>
          <Select
            value={filterStatus}
            onChange={(item) => setFilterStatus(item)}
            placeholder="Status"
            options={affiliate_payment_statuses}
            isClearable
          />
        </Col>

      </Row>
    </div>
  );
}
